<template>

  <div>

    <b-modal id="zalo-list-modal" ref="zalo-list-modal" title="Danh sách nhóm Zalo" size="xl" :hide-header-close="false"
      :no-close-on-backdrop="true" @cancel="resetModal" @hide="resetModal" hide-footer>
      <b-overlay>
        <b-container class="p-0">
          <form ref="form">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <p v-if="remainZaloGroup !== null" class="mb-0">Nhóm khả dụng: {{ remainZaloGroup }}</p>
              <p v-else class="mb-0">Đang cập nhật...</p>

              <b-form-checkbox v-model="onlyExpiring" switch @change="handleFilterExpiring">
                Chỉ hiện nhóm sắp hết hạn
              </b-form-checkbox>
            </div>

            <b-row>
              <b-col>
                <template-table :column="column" :data="zaloGroup" :paging="paging" :tableAction="false"
                  :selectAction="false" :searchAction="false" boundary="window" @page-change="handlePageChange"
                  @page-size-change="handlePageSizeChange">

                  <template v-slot:body="{ item }">
                    <td>
                      <div class="grap-info">
                        <avatar size="40px" :src="item.avatar" :rounded="true" />

                        <div class="d-flex flex-column ml-3">
                          <p class="mb-0 module-list-page__body__updater-name">
                            {{ item.name }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td style="width: 15px">
                      <action-dropdown :value="item" :show_edit="isInsertPermission"
                        :show_copy="false"
                        :boundary="data.length > 2 ? 'scrollParent' : 'window'" :show_view="true" 
                        @edit="editItem(item)"
                        @view="viewItem(item.group_id)" 
                        @delete="showPopupDeleteStatus(item.group_id)">
                      </action-dropdown>
                    </td>
                    <td style="width: 30px">
                      {{ item.total_member }}
                    </td>
                    <td>
                      <span :class="{ 'text-danger': isExpiring(item.valid_through) }">
                        {{ item.valid_through }}
                      </span>
                      <template v-if="isExpiring(item.valid_through)">
                        <small class="text-danger">
                          <p class="mb-1">
                            Sắp hết hạn
                          </p>
                        </small>
                        <b-button
                          size="sm"
                          variant="outline-success"
                          :disabled="isRenewing"
                          @click.stop="showPopupRenew(item)"
                        >
                          Gia hạn
                        </b-button>
                      </template>
                    </td>

                    <!-- <td>
                      {{ changeText(item.group_description) }}
                    </td> -->
                    <td>
                      {{ item.group_link }}
                    </td>
                  </template>
                </template-table>
                <div class="d-flex justify-content-end align-items-center mt-3">
                  <b-button class="btn btn-plain ml-2" href="#" @click.stop="handleCancel" tabindex="0">
                    Thoát
                  </b-button>
                  <b-button class="btn btn-success ml-2" href="#" @click.stop="handleRefresh" tabindex="0"
                    :disabled="isSubmitting">
                    <span class="svg-icon">
                      <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
                    </span>
                    Làm mới
                  </b-button>
                  <b-button class="btn btn-success ml-2" type="button" @click="showModalCreate">
                    <span class="svg-icon">
                      <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
                    </span>
                    Thêm mới
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </form>
        </b-container>
      </b-overlay>

      <template #modal-footer>
        <!-- Your modal footer buttons go here -->
      </template>
    </b-modal>

    <b-modal id="detail-modal" ref="detail-modal" title="Thông tin của nhóm" size="xl" @ok="handleSuccessOk"
      hide-footer>
      <b-container>
        <row>
          <b-overlay>
            <b-container class="p-0">
              <form ref="form">
                <b-row>
                  <b-col>
                    <template-table :column="columnDetail" :data="this.zaloGroupDetail" :paging="paging"
                      :tableAction="false" :selectAction="false" :searchAction="false" boundary="window">
                      <template v-slot:body="{ item }">
                        <!-- <td v-if="!item.oa_id"> -->
                        <td>
                          <div class="grap-info">
                            <avatar size="100px" :src="item.avatar" :rounded="true" />
                            <div class="d-flex flex-column ml-3">
                              <p style="font-size: 16px">
                                {{ item.name }}
                              </p>
                            </div>
                          </div>
                        </td>

                        <td>
                          <!-- <td v-if="!item.oa_id"> -->
                          {{ item.user_id }}
                        </td>
                        <td>
                           <basic-select
                            label="Người tham gia"
                            placeholder="Chọn người tham gia"
                            data-vv-As="Người tham gia"
                            track-by="id"
                            value-label="name"
                            :options="listCustomerReceivesJoin"
                            changeValueByObject
                            :value="selectedUserJoinByZaloUserId[item.user_id] || null"
                            @input="onSelectUserJoin(item.user_id, $event)"
                            name="userJoin"
                          />
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div
                              class="btn btn-success"
                              role="button"
                              tabindex="0"
                              @click="updateZaloId(item.user_id)"
                            >
                              Xác nhận
                            </div>
                            <div
                              v-if="isZaloUserExisted(item.user_id)"
                              class="btn btn-danger ml-2"
                              role="button"
                              tabindex="0"
                              @click="cancelZaloId(item.user_id)"
                            >
                              Huỷ
                            </div>
                          </div>
                        </td>
                        <!-- <td
                          style="margin-top: 40px; display: block"
                          v-if="!item.oa_id"
                        >
                          <div
                            @mouseover="hovered = true"
                            @mouseleave="hovered = false"
                            style="display: inline-block"
                          >
                            <basic-select
                              v-if="
                                !listExisted.some(
                                  (x) => x.zaloUserId === item.user_id,
                                )
                              "
                              placeholder="--- Chọn số ---"
                              name="phoneListMapping"
                              :options="phoneListMapping"
                              value-label="text"
                              track-by="text"
                              :multiple="false"
                              v-model="selectedPhone"
                              :disabled="isDisabled"
                            />
                            {{ getPhoneNumber(item.user_id) }}
                          </div>
                        </td> -->

                        <!-- <td v-if="!item.oa_id">
                          <b-button
                            v-if="
                              !listExisted.some(
                                (x) => x.zaloUserId === item.user_id,
                              )
                            "
                            class="btn btn-success ml-3"
                            type="button"
                            @click="
                              submitLink(
                                item.user_id,
                                splitSelectedPhone(item.user_id),
                              )
                            "
                          >
                            Liên kết
                          </b-button>

                          <b-button
                            v-if="
                              listExisted.some(
                                (x) => x.zaloUserId === item.user_id,
                              )
                            "
                            class="btn btn-inactive ml-3"
                            type="button"
                            @click="showPopupUnLink(item.user_id)"
                          >
                            Hủy liên kết
                          </b-button>
                        </td> -->
                      </template>
                    </template-table>
                  </b-col>
                </b-row>
              </form>
            </b-container>
          </b-overlay>
        </row>
      </b-container>
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button class="btn btn-plain ml-2" href="#" @click.stop="cancelItem" tabindex="0">
          Quay lại
        </b-button>
      </div>
    </b-modal>
    <ZaloModal ref="zalo-modal" @call-refresh-list="getGroupOA" />
    <ZaloEditModal ref="zalo-edit-modal" @call-refresh-list="getGroupOA" :groupItem="groupItem" />
  </div>
</template>
<script>
import ZaloModal from './ZaloModal.vue';
import { handleZaloOutOfMoney } from '@/core/utils/zaloOutOfMoney';
import ZaloEditModal from './ZaloEditModal.vue';

// Giới hạn count của Zalo API getgroupsofoa
const MAX_ZALO_GROUP_FETCH = 50;

export default {
  components: {
    ZaloModal,
    ZaloEditModal,
  },
  name: 'ZaloListModal',
  props: {
    coursesList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    'paging.page'() {
      this.getGroupOA(this.paging.page, this.paging.pageSize);
      this.remainZaloGroup();
    },
    'paging.size'() {
      this.getGroupOA();
      this.remainZaloGroup();
    }
  },
  computed: {
    isDisabled() {
      return !this.hovered;
    },

  },
  data() {
    return {
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      data: '',
      selectedPackage: '',
      coursesId: '',
      column: [
        {
          key: 'name',
          label: 'Tên nhóm zalo',
          sortable: false,
          style: {
            width: '50%',
          },
        },
        {
          key: 'actionDropdown',
          label: '',
          sortable: false,
          style: {
            width: '5%',
          },
        },
        {
          key: 'total_member',
          label: 'Số lượng',
          sortable: false,
          style: {
            width: '10%',
          },
        },
        // {
        //   key: 'group_description',
        //   label: 'Mô tả nhóm',
        //   sortable: false,
        //   style: {
        //     width: '25%',
        //   },
        // },
        {
          key: 'valid_through',
          label: 'Ngày hết hạn',
          sortable: false,
        },
        {
          key: 'group_link',
          label: 'Link tham gia nhóm',
          sortable: false,
        },
      ],
      columnDetail: [
        {
          key: 'name',
          label: 'Tên thành viên',
          sortable: false,
          style: {
            width: '35%',
          },
        },

        {
          
          key: 'user_id',
          label: 'User Zalo Id',
          sortable: false,
          style: {
            width: '15%',
          },
          
        },
          {
          key: 'userJoin',
          label: 'Danh sách tham gia',
          sortable: false,
          style: {
            width: '20%',
          },
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
          style: {
            width: '20%',
          },
        },
        // {
        //   key: 'phone_group',
        //   label: 'Tài khoản liên kết',
        //   sortable: false,
        //   style: {
        //     width: '25%',
        //   },
        // },
        // {
        //   key: 'mapping_phone',
        //   label: 'Liên kết',
        //   sortable: false,
        //   style: {
        //     width: '15%',
        //   },
        // },
      ],

      coach_id: '',
      isSubmitting: false,
      zaloGroup: [],
      zaloGroupDetail: [],
      phoneListMapping: [],
      selectedPhone: null,
      listExisted: [],
      parts: [],
      listCustomerReceivesJoin: [],
      selectedUserJoinByZaloUserId: {},
      // ZaloEditModal khai báo prop này là Object, khởi tạo mảng rỗng sẽ warn ngay
      // lần render đầu. null hợp lệ vì prop không required.
      groupItem: null,
      hovered: false,
      isLoading: false,
      isRenewing: false,
      onlyExpiring: false,
      remainZaloGroup: '',
      existedZaloUserIdSet: {},
    };
  },

  async created() {
    this.handleRefresh();

  },
  methods: {
    // Được gọi từ @cancel/@hide của modal và từ handleCancelSuccess/handleSuccessOk.
    // Trả state về ban đầu để lần mở sau không giữ trang cũ và nhóm đã chọn cũ.
    resetModal() {
      this.paging.page = 1;
      this.groupItem = null;
    },
    changeText(item) {
      if (item.includes('Chung')) {
        return 'Group chung';
      } else {
        return 'Group Health Coach';
      }
    },
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength
        ? text.substring(0, maxLength) + '...'
        : text;
    },
    cancelItem() {
      this.$refs['detail-modal'].hide();
    },
    async viewItem(group_id) {
      this.$store.commit('context/setLoading', true);
      try {
        // reset per-group derived state
        this.existedZaloUserIdSet = {};
        this.selectedUserJoinByZaloUserId = {};

        const params = {
          group_id: group_id,
          offset: 0,
          count: 50,
        };
        const response = await this.$api.get('/ZaloZnsLog/DetailGroup', {
          params,
        });

        this.zaloGroupDetail = response.data.members;
        this.paging.total = response.data.total;
      await this.GetListCustomerReceivesJoin();
        await this.checkZaloUsersInGroup();
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Lấy danh sách nhóm thành công.',
        });
        this.$refs['detail-modal'].show();
      } catch (error) {
        this.$toastr.w({
          title: 'Cảnh báo!',
          msg: 'Nhóm chưa được chỉ định vào khóa.',
        });
        console.error(error);
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    async deletedGroup(group_id) {
      try {
        const body = {
          group_id: group_id,
        };

        await this.$api.post('/ZaloZnsLog/DeleteGroupOa', body, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Nhóm zalo được xóa thành công.',
        });
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error,
        });
        this.isSubmitting = false;
      }
    },
    async showPopupDeleteStatus(group_id) {
      const result = await this.$swal({
        title: 'Xác nhận',
        text: 'Bạn có chắc chắn muốn xóa nhóm không? Không thể quay lại nhóm sau khi đã xóa',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      });
      if (result) {
        await this.deletedGroup(group_id);
        this.handleRefresh();
      }
    },

    async editItem(item) {
      this.groupItem = item;
      this.$refs['zalo-edit-modal'].show();
    },

    async showPopupUnLink(user_id) {
      const result = await this.$swal({
        title: 'Xác nhận',
        text: 'Bạn có chắc chắn muốn bỏ liên kết tài khoản không?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      });
      if (result) {
        await this.submitUnLink(user_id, this.splitSelectedPhone(user_id));
      }
    },
    showModalCreate() {
      this.$refs['zalo-modal'].show();
    },

    getPhoneNumber(user_id) {
      const filterPhone = this.listExisted.find((x) => x.zaloUserId == user_id);
      return filterPhone ? filterPhone.phoneNumber : null;
    },
    async getPhoneList(courseId) {
      const response = await this.$api.get(
        `/CustomerReceives/MappingZalo?courseId=${courseId}`,
      );
      this.phoneListMapping = response;
      await this.getListAccount();
    },

    async getListAccount() {
      const respone = await this.$api.get(`/Account/ZaloIdExist`);
      this.listExisted = respone
        .filter((item) => item.zaloUserId != null)
        .map((item) => {
          return {
            zaloUserId: item.zaloUserId,
            phoneNumber: item.phoneNumber,
          };
        });
    },

    splitSelectedPhone(user_id) {
      // Check if selectedPhone exists, and split it if it does
      if (this.selectedPhone) {
        this.parts = this.selectedPhone.split('|');

        // Return the second part if it exists
        if (this.parts[1]) {
          return this.parts[1];
        }
      }

      // If parts[1] is not found, try to get the phone number using the user_id
      const phoneNumber = this.getPhoneNumber(user_id);

      // Return the phone number or null if not found
      return phoneNumber || null;
    },

    async submitLink(user_id, phone) {
      try {
        this.$store.commit('context/setLoading', true);

        const response = await this.$api.get(
          `/CustomerReceives/MappingZaloPortal?user_id=${user_id}&phone=${phone}`,
        );

        if (response.data.error) {
          this.$toastr.e({
            title: 'Thất bại!',
            msg: response.message || 'Đã xảy ra lỗi không xác định.',
          });
          return;
        }

        await this.getListAccount();

        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Liên kết thành công.',
        });
      } catch (error) {
        this.$toastr.e({
          title: 'Thất bại!',
          msg: error.message || 'Liên kết không thành công.',
        });
      } finally {
        // Reset the loading state
        this.$store.commit('context/setLoading', false);
      }
    },

    async submitUnLink(user_id, phone) {
      this.$store.commit('context/setLoading', true);

      try {
        await this.$api.get(
          `/CustomerReceives/UnMappingZaloPortal?user_id=${user_id}&phone=${phone}`,
        );

        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Hủy liên kết thành công.',
        });
      } catch {
        this.$toastr.e({
          title: 'Lỗi',
          msg: 'Hủy liên kết thất bại.',
        });
      } finally {
        await this.getListAccount();
        this.$store.commit('context/setLoading', false);
      }
    },

    async getListPhoneNotMap() {
      const coachList = await this.$api.get('/Account/ZaloIdCoachs');
      this.coachesList = coachList.data;
    },

    show() {
      this.$refs['zalo-list-modal'].show();
    },
    hide() {
      this.$refs['zalo-list-modal'].hide();
    },

    async getDetailGroupOA(group_id) {
      const body = {
        group_id: group_id,
      };

      // Make the API call with JSON body
      const response = await this.$api.post('/ZaloZnsLog/DetailGroup', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      this.zaloGroupDetail = response.data;
    },
    async GetListCustomerReceivesJoin () {
      try {
        this.$store.commit('context/setLoading', true);
        const data = await this.$api.get('/CustomerReceives/All?status=1');
        this.listCustomerReceivesJoin = data.map((item) => ({
          id: item.id,
          name: item.name,
        }));
      } catch (error) {
        console.error('Error fetching ListCustomerReceivesJoin:', error);
      } finally {
        this.$store.commit('context/setLoading', false);
       }
    },
    isZaloUserExisted(userZaloId) {
      return !!this.existedZaloUserIdSet?.[userZaloId];
    },
    async checkZaloUsersInGroup() {
      const userIds = (this.zaloGroupDetail || [])
        .map((x) => x?.user_id)
        .filter((x) => x !== undefined && x !== null && x !== '');

      if (!userIds.length) {
        this.existedZaloUserIdSet = {};
        return;
      }

      try {
        const res = await this.$api.get('/CustomerReceives/CheckZaloUser', {
          params: {
            userIds: userIds.join(',')
          },
        });
        // API returns List<(Guid Id, string UserZaloId)>
        // Serialized as array of { id, userZaloId }
        const resultList = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
        const map = {};
        resultList.forEach((item) => {
          const zaloId = item.userZaloId || item.UserZaloId || item.item2 || item.Item2;
          if (zaloId) {
            map[zaloId] = true;
          }

          // Auto-select the matching participant by GUID id
          const guid = item.id || item.Id || item.item1 || item.Item1;
          if (guid && zaloId) {
            const matched = this.listCustomerReceivesJoin.find(
              (c) => c.id === guid || c.id?.toLowerCase?.() === guid?.toLowerCase?.()
            );
            if (matched) {
              this.$set(this.selectedUserJoinByZaloUserId, zaloId, matched);
            }
          }
        });
        this.existedZaloUserIdSet = map;
      } catch (error) {
        console.error('Error checking zalo user ids:', error);
        this.existedZaloUserIdSet = {};
      }
    },
    onSelectUserJoin(userZaloId, customerReceive) {
      this.$set(
        this.selectedUserJoinByZaloUserId,
        userZaloId,
        customerReceive || null,
      );
    },
    async updateZaloId (userZaloId) {
      try {
        const selectedCustomerReceive =
          this.selectedUserJoinByZaloUserId[userZaloId];
        const customerReceiveId = selectedCustomerReceive?.id;
        if (!customerReceiveId) {
          this.$toastr.w({
            title: 'Cảnh báo!',
            msg: 'Vui lòng chọn người tham gia trước khi xác nhận.',
          });
          return;
        }

        this.$store.commit('context/setLoading', true);
        await this.$api.put(
          `/CustomerReceives/UpdateZaloId?id=${customerReceiveId}&userId=${userZaloId}`,
        );
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Cập nhật Zalo ID thành công.',
        });
      } catch (error) {
        console.error('Error updating Zalo ID:', error);
      } finally {
        this.$store.commit('context/setLoading', false);
        this.cancelItem();
       }
    },
    async cancelZaloId (userZaloId) {
      try {
        const selectedCustomerReceive =
          this.selectedUserJoinByZaloUserId[userZaloId];
        const customerReceiveId = selectedCustomerReceive?.id;
        if (!customerReceiveId) {
          this.$toastr.w({
            title: 'Cảnh báo!',
            msg: 'Không tìm thấy người tham gia để huỷ.',
          });
          return;
        }

        this.$store.commit('context/setLoading', true);
        await this.$api.put(
          `/CustomerReceives/UpdateZaloId?id=${customerReceiveId}&userId=`,
        );
        // Clear local state
        this.$set(this.selectedUserJoinByZaloUserId, userZaloId, null);
        this.$delete(this.existedZaloUserIdSet, userZaloId);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Huỷ liên kết Zalo ID thành công.',
        });
      } catch (error) {
        console.error('Error cancelling Zalo ID:', error);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Huỷ liên kết thất bại.',
        });
      } finally {
        this.$store.commit('context/setLoading', false);
       }
    },
    async getGroupOA() {
      this.$store.commit('context/setLoading', true);

      try {
        // Chế độ lọc "sắp hết hạn": Zalo không hỗ trợ lọc phía server nên phải
        // lấy 1 lần tối đa 50 nhóm (giới hạn của getgroupsofoa) rồi lọc client-side.
        const offset = this.onlyExpiring
          ? 0
          : (this.paging.page - 1) * this.paging.pageSize;
        const count = this.onlyExpiring
          ? MAX_ZALO_GROUP_FETCH
          : this.paging.pageSize;

        const res = await this.$api.get("/ZaloZnsLog/GetValidGroupOA", {
          params: { offset, count }
        });

        const { total, groups } = res.data;

        if (this.onlyExpiring) {
          const expiring = (groups || []).filter((g) =>
            this.isExpiring(g.valid_through),
          );
          this.zaloGroup = expiring;
          this.paging.total = expiring.length;

        } else {
          this.zaloGroup = groups;
          this.paging.total = parseInt(total);
        }
      } catch (err) {
        console.error("Error:", err);
      } finally {
        this.$store.commit('context/setLoading', false);

      }
    },

    async handleFilterExpiring() {
      // @change của b-form-checkbox chạy trước khi v-model cập nhật xong
      await this.$nextTick();
      this.paging.page = 1;
      await this.getGroupOA();
    },

    handlePageChange(page) {
      this.paging.page = page;
      this.handleRefresh();

    },

    handlePageSizeChange(size) {
      this.paging.pageSize = size;
      this.paging.page = 1;
      this.handleRefresh();
    },

    handleCancelSuccess() {
      this.$refs['success-modal'].hide();
      this.resetModal();
    },
    handleCancel() {
      this.hide();
    },
    handleSuccessOk() {
      this.hide();
      this.resetModal();
    },
    async handleRefresh() {
      await this.getGroupOA();
      await this.getZaloRemain();
    },
    async getZaloRemain() {
      try {
        const response = await this.$api.get(
          '/CustomerReceives/remainGroupZalo',
        );
        this.remainZaloGroup = response.data;
      } catch (error) {
        console.error('Error fetching remain groups:', error);
      }
    },

    async showPopupRenew(item) {
      const result = await this.$swal({
        title: 'Xác nhận gia hạn',
        text:
          `Gia hạn nhóm "${item.name}" sẽ MUA MỘT GÓI MỚI và bị tính phí vào tài khoản ZCA. ` +
          `Bạn có chắc chắn muốn tiếp tục không?`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ bỏ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: '',
            closeModal: true,
          },
        },
      });
      if (result) {
        await this.renewGroup(item);
      }
    },

    async renewGroup(item) {
      this.isRenewing = true;
      this.$store.commit('context/setLoading', true);
      try {
        const res = await this.$api.post('/ZaloZnsLog/RenewGroupAsset', {
          group_id: item.group_id,
        });
        const validThrough = res?.data?.valid_through;
        this.$toastr.s({
          title: 'Thành công!',
          msg: validThrough
            ? `Đã gia hạn nhóm "${item.name}" đến ${validThrough}.`
            : `Đã gia hạn nhóm "${item.name}".`,
        });
        await this.handleRefresh();
      } catch (error) {
        if (await handleZaloOutOfMoney(this, error)) return;
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error.message || 'Gia hạn nhóm thất bại.',
        });
      } finally {
        this.isRenewing = false;
        this.$store.commit('context/setLoading', false);
      }
    },

    isExpiring(dateStr) {
      if (!dateStr) return false;

      // Parse dd/MM/yyyy (like "14/10/2025")
      const [day, month, year] = dateStr.split("/").map(Number);
      const validDate = new Date(year, month - 1, day);

      const today = new Date();
      // Clear time part
      today.setHours(0, 0, 0, 0);

      const diffTime = validDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays <= 7; // true if within 7 days
    },
  },
};
</script>
<style scoped>
.no-footer .modal-footer {
  display: none;
}

.group-name {
  display: inline-block;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.bold-label {
  font-weight: bold;
  color: #333;
  text-align: left;
}

button.btn.btn-secondary.collapsed {
  margin: -15px;
}

button.btn.btn-secondary.not-collapsed {
  margin: -15px;
}

.grap-info {
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 20px;
  align-items: center;
  width: 100%;
}

.multiselect__clear {
  display: none !important;
}

.basic-select-hover {
  cursor: pointer;
  /* Change cursor to indicate interactivity */
  border: 1px solid #ccc;
  /* Optional styling */
}

.basic-select-hover:hover {
  border-color: #007bff;
  /* Change border color on hover */
}
</style>
